<div [formGroup]="formGroup" class="control control--input control--textbox" [hidden]="hidden">
  <div *ngIf="model.hasLabel" class="control__header">
    <label class="control__header__label" [for]="model.key" [title]="model.label">{{ model.label }}</label>
    <div class="control__header__error" *ngIf="hasError" [title]="error">{{ error }}</div>
  </div>
  <input
    pInputText
    [ngClass]="classes"
    [readonly]="model.readonly"
    [type]="model.type"
    [autocomplete]="model.autocomplete"
    [id]="model.key"
    [placeholder]="model.placeholder"
    (change)="onChangeEvent($event)"
    (input)="onInput.emit($event)"
    (focus)="onFocus.emit($event)"
    (blur)="onBlur.emit($event)"
    [formControlName]="model.key" />
</div>